import { useT } from '../../i18n/i18n';
import { readInspectorProfile, type InspectorProfile } from '../../state/preferences';
import { Button, SheetShell } from '../../ui/components';
import { LicenceBinding } from '../settings/LicenceBinding';

// The inspector's licence, bound over the New Inspection form (Owner device test 2026-09-12: a formal
// inspection needs it, and sending the inspector to Settings discarded everything already filled in).
// Since 2026-10-19 (Owner decision list item 50) the licence is not typed onto the device: it is checked
// against New York's public list and bound to the account once (src/features/settings/LicenceBinding.tsx).
// Binding here is exactly binding in Settings; Close writes nothing.
export function LicenceSheet(props: { onSaved: (profile: InspectorProfile) => void; onClose: () => void }) {
  const { t } = useT();
  return (
    <SheetShell
      title={t('settings.profile')}
      onClose={props.onClose}
      testId="new-licence-sheet"
      footer={
        <Button variant="text" onClick={props.onClose} testId="new-licence-cancel">
          {t('shell.cancel')}
        </Button>
      }
    >
      <LicenceBinding idPrefix="new-licence" onBound={() => props.onSaved(readInspectorProfile())} />
    </SheetShell>
  );
}
